import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { useTravelerProfileSuggestionsStore } from '../../store';

/**
 * Inline info banner shown after the AI import pipeline runs and produces
 * nothing actionable. Replaces the previous transient snackbar so the
 * "no new info" verdict stays on screen until the user explicitly dismisses
 * it via the X.
 *
 * Reads visibility from the suggestions context, so it just needs to be a
 * descendant of `TravelerProfileSuggestionsProvider`. Place it in the page
 * layout alongside `SuggestionValidationAlert`.
 */
const NoSuggestionsAlert = () => {
  const ctx = useTravelerProfileSuggestionsStore();
  if (!ctx) return null;

  const { noResultsAlertOpen, dismissNoResultsAlert } = ctx;
  if (!noResultsAlertOpen) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="info" onClose={dismissNoResultsAlert}>
        <AlertTitle>No new info found to import.</AlertTitle>
      </Alert>
    </Box>
  );
};

export default NoSuggestionsAlert;
